import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/site/JsonLd";
import { SchoolComparisonPage } from "@/components/site/SchoolComparisonPage";
import { SCHOOL_COMPARISON, comparisonJsonLd } from "@/content/school-comparison";
import { PAGE_META } from "@/content/page-meta";
import { absoluteUrl, seoLinks, ogImage } from "@/lib/seo";

const PATH = "/en/swedish-international-or-spanish-school";
const meta = PAGE_META["cmp:en"];

export const Route = createFileRoute("/en/swedish-international-or-spanish-school")({
  head: () => ({
    meta: [
      { title: meta.title },
      { name: "description", content: meta.description },
      { property: "og:title", content: meta.title },
      { property: "og:description", content: meta.description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl(PATH) },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "en_GB" },
      ...ogImage(),
    ],
    links: seoLinks(PATH),
  }),
  component: ComparisonEnRoute,
});

function ComparisonEnRoute() {
  const content = SCHOOL_COMPARISON.en;
  return (
    <>
      <JsonLd scripts={comparisonJsonLd(content, absoluteUrl(PATH), "en")} />
      <SchoolComparisonPage locale="en" content={content} />
    </>
  );
}
